if (!customElements.get('newcomer-deals-slider')) {
  class NewcomerDealsSlider extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-slider-grid]');
      this.previousButton = this.querySelector('[data-slider-prev]');
      this.nextButton = this.querySelector('[data-slider-next]');

      if (!this.grid || !this.previousButton || !this.nextButton) return;

      this.previousButton.addEventListener('click', () => this.move(-1));
      this.nextButton.addEventListener('click', () => this.move(1));
      this.grid.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons());
      requestAnimationFrame(() => this.updateButtons());
    }

    move(direction) {
      const item = this.grid.querySelector('[data-slider-item]');
      if (!item) return;

      const styles = window.getComputedStyle(this.grid);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const visibleItems = Math.max(1, Math.floor(this.grid.clientWidth / (item.clientWidth + gap)));

      this.grid.scrollBy({
        left: direction * (item.clientWidth + gap) * visibleItems,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      const maxScroll = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
      this.previousButton.disabled = this.grid.scrollLeft <= 2;
      this.nextButton.disabled = maxScroll <= 2 || this.grid.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('newcomer-deals-slider', NewcomerDealsSlider);
}

const newcomerDealsPage = document.querySelector('.newcomer-deals');
const selectedDiscountLevel = new URLSearchParams(window.location.search).get('discount');

if (newcomerDealsPage && ['1', '2', '3'].includes(selectedDiscountLevel)) {
  const activeLevel = newcomerDealsPage.querySelector(`[data-discount-level="${selectedDiscountLevel}"]`);

  if (activeLevel) {
    newcomerDealsPage.classList.add('newcomer-deals--filtered');
    activeLevel.classList.add('is-active');

    const levelTitle = activeLevel.querySelector('.newcomer-deals__product-heading h2');
    if (levelTitle) document.title = `${levelTitle.textContent.trim()} | ${document.title}`;
  }
}
